<div class="video-container z-30">
  @if (videoURL) {
    <iframe
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      class="z-30"
      frameborder="0"
      height="100%"
      loading="lazy"
      width="100%"
      [src]="embedUrl"></iframe>
  } @else {
    <!-- ui-store-migrate (G8): <div class="loading-placeholder"> → <app-ui-skeleton [single]="true" width="..." height="..."> with the inner text rendered as a sibling. The `.loading-placeholder` @utility class in styles/styles.css can sunset after this site migrates. -->
    <div class="loading-placeholder">
      <span>No video available</span>
    </div>
  }
</div>
